import { useMutation, useQuery } from '@tanstack/react-query';
import { ProjectSourceType } from 'api/project';
import { TemplateState, TemplatesAPI } from 'data/templates/api';
import { ProjectTemplatesAPI } from 'data/templates/projects/api';
import { oneDay } from '../constants';
export const PROJECT_TEMPLATE_OPTIONS_QUERY_KEY = [
    'PROJECT_TEMPLATE_OPTIONS_QUERY_KEY'
];
const usePublishedProjectTemplateOptionsQuery = ()=>{
    return useQuery(PROJECT_TEMPLATE_OPTIONS_QUERY_KEY, ()=>{
        return ProjectTemplatesAPI.getAllTemplates();
    }, {
        staleTime: oneDay,
        refetchOnWindowFocus: false,
        select: (data)=>{
            return data.filter(({ state })=>state === TemplateState.Published).map(({ templateId, templateName, state, folderId, folderName })=>({
                    label: templateName !== null && templateName !== void 0 ? templateName : '',
                    value: templateId,
                    sourceType: ProjectSourceType.Template,
                    sourceId: templateId,
                    state,
                    folderId,
                    folderName
                }));
        }
    });
};
const useGetTemplateDependenciesMap = ()=>{
    return useMutation((payload)=>TemplatesAPI.getTemplateDependenciesMap(payload));
};
export { usePublishedProjectTemplateOptionsQuery, useGetTemplateDependenciesMap };
